import DatePicker from 'components/controls/fields/DatePicker';
import FormField from 'components/controls/form/FormField';
import React from 'react';

export default function FormDatePicker({error, label, ...props}) {
    return (
        <FormField
            error={error}
            label={label}
        >
            <DatePicker
                error={error}
                {...props}
            />
        </FormField>
    );
}



// WEBPACK FOOTER //
// ./src/components/controls/fields/FormDatePicker.jsx